import { EventStatus } from '@wix/events-types';
export var UPCOMING_EVENT_STATUSES = [EventStatus.SCHEDULED, EventStatus.STARTED];
export var PAST_EVENT_STATUSES = [EventStatus.ENDED, EventStatus.CANCELED];
export var WIX_FEE_RATE = 0.025;
//# sourceMappingURL=event.js.map